<!--
 * @Descripttion: 卖家中心
-->
<template>
<div class="sellBody">
	<div class="sellTitle">商家入驻信息 <span @click="MerchantSettledListDialog = true"
			style="color: #409eff;margin-right: 20px;cursor: pointer;font-size: 14px;font-weight:400;float: right;"><i
				class="el-icon-refresh"></i> 变更商家信息</span></div>
	<div class="sellcont" v-if="dataList.supplierInfo">
		<div class="sellcontItem"><span class="selltemm">企业名称：</span>{{ dataList.supplierInfo.name }}</div>
		<div class="sellcontItem"><span class="selltemm">企业类型：</span>{{ suppTYPE[dataList.supplierInfo.type] }}</div>

		<div class="sellcontItem"><span class="selltemm">企业地址：</span>{{ dataList.supplierInfo.address }}</div>
		<div class="sellcontItem"><span class="selltemm">申请时间：</span>{{ dataList.supplierInfo.applyTime }}</div>
		<div class="sellcontItem"><span class="selltemm">注册资金：</span>
			{{ dataList.supplierInfo.registeredCapital !== null ? dataList.supplierInfo.registeredCapital + '万': null }}</div>
		<div class="sellcontItem"><span class="selltemm">审核状态：</span>{{ suppStatus[dataList.supplierInfo.status] }}</div>
		<div class="sellcontItem"><span class="selltemm">审核信息：</span>{{ dataList.supplierInfo.checkResultNotice || '无'
		}}
		</div>
		<div class="sellcontItem"><span class="selltemm">统一社会信用代码/机构号：</span>{{ dataList.supplierInfo.creditCode }}
		</div>
		<div class="sellcontItem"><span class="selltemm">负责人姓名：</span>{{ dataList.supplierInfo.headManName||dataList.shopInfo.shopName }}</div>
		<div class="sellcontItem"><span class="selltemm">负责人电话：</span>{{ dataList.supplierInfo.contactNumber || dataList.shopInfo.shopPhone }}</div>
		<div class="sellcontItem"><span class="selltemm">法人姓名：</span>{{ dataList.supplierInfo.legalPerson }}</div>
		<div class="sellcontItem"><span class="selltemm">法人身份证号：</span>{{ dataList.supplierInfo.idCard }}</div>

		<div class="sellcontItem" style=" width: 46%; "><span class="selltemm">企业介绍：</span>{{
			dataList.supplierInfo.introduce }}
		</div>
		<div class="sellcontItem" style=" width: 46%; "><span class="selltemm">经营范围：</span>{{
			dataList.supplierInfo.businessScope }}
		</div>

	</div>
	<div class="sellTitle">店铺信息统计</div>
	<div class="sellcont" v-if="dataList.shopInfo">
		<div class="sellcontItem"><span class="selltemm">店铺名称：</span>{{ dataList.shopInfo.shopName }}</div>
		<!-- <div class="sellcontItem"><span class="selltemm">服务热线：</span>{{dataList.shopInfo.serviceHotline}}</div> -->
		<div class="sellcontItem"><span class="selltemm">服务周期：</span>{{ dataList.shopInfo.serviceDate }}</div>
		<!-- <div class="sellcontItem"><span class="selltemm">开始时间：</span>{{dataList.shopInfo.serviceBeginTime}}</div>
	<div class="sellcontItem"><span class="selltemm">结束时间：</span>{{dataList.shopInfo.serviceEndTime}}</div> -->
		<div class="sellcontItem"><span class="selltemm">商品总量：</span>{{ dataList.goodsNum || '0' }} 个</div>
		<div class="sellcontItem"><span class="selltemm">上架数量：</span>{{ dataList.goodsShelfNum || '0' }} 个</div>
	</div>
	<div class="sellTitle">实时概况</div>
	<div class="sellCard">
		<div class="sellItem" style="color:#2469f1">
			<span class="iconfont sellItemIcon">&#xe767;</span>
			<div class="sellItemTitle">总计订单（笔）</div>
			<div class="sellItemNum">{{ dataList.totalNum || '0' }}</div>
		</div>
		<div class="sellItem" style="color:#00b77a">
			<span class="iconfont sellItemIcon">&#xe8ba;</span>
			<div class="sellItemTitle">总成交金额（元）</div>
			<div class="sellItemNum">{{ dataList.totalAmount || '0' }}</div>
		</div>
		<div class="sellItem" style="color:#ffa700">
			<span class="iconfont sellItemIcon">&#xe785;</span>
			<div class="sellItemTitle">本月订单（笔）</div>
			<div class="sellItemNum">{{ dataList.monthTotalNum || '0' }}</div>
		</div>
		<div class="sellItem" style="color:#9c27b0">
			<span class="iconfont sellItemIcon">&#xe8c4;</span>
			<div class="sellItemTitle">本月成交金额（元）</div>
			<div class="sellItemNum">{{ dataList.monthTotalAmount || '0' }}</div>
		</div>
	</div>
	<div class="sellTitle" style=" display: flex; justify-content: space-between;margin-bottom: 10px; ">订单统计
		<el-date-picker @change="confirmDate" value-format="yyyy-MM-dd HH:mm:ss" style=" margin-top: 10px; "
			v-model="value2" type="datetimerange" :picker-options="pickerOptions" range-separator="至"
			start-placeholder="开始日期" end-placeholder="结束日期" align="right">
		</el-date-picker>
	</div>

	<div class="sellEchartsLine" ref="ecLine1"></div>
	<!--    <el-empty description="暂无数据" v-show="!hasLineData"></el-empty>-->

	<div style="display:flex">
		<!-- <div style="flex:1">
			<div class="sellTitle">用户分析</div>
			<div class="sellEchartsFunnel" ref="ecFunnel1"></div>
		</div> -->
		<!-- <div style="width:20px;height:20px"></div> -->
		<div style="flex:1">
			<div class="sellTitle">用户成交订单分析</div>
			<div class="sellEchartsBar" ref="ecbar1"></div>
		</div>
	</div>
	<el-dialog title="变更商家信息" :visible.sync="ChangeMerchantDialog" :close-on-click-modal="false" v-dialogDrag
		width="70%" top="5vh">
		<ChangeMerchantSettled v-if="ChangeMerchantDialog" :ruleForm="ChangeSupplierInfo"
			@changePhoneSuccess="ChangeMerchantDialogSuccess"></ChangeMerchantSettled>
	</el-dialog>
	<el-dialog title="商家变更列表" :visible.sync="MerchantSettledListDialog" :close-on-click-modal="false" v-dialogDrag
		width="70%" top="5vh">
		<MerchantSettledList v-if="MerchantSettledListDialog" @MerchantSuccess="MerchantSettledListDialogSuccess">
		</MerchantSettledList>
	</el-dialog>

</div>
</template>

<script>
import { getStoreTransactionStatistics, getStoreUserTransactionAnalysisAndStatistics } from "@/const/SellerCenter";
import { getLastWeekData } from '@/utils/function'
import ChangeMerchantSettled from "@/components/DialogComponent/ChangeMerchantSettled";
import MerchantSettledList from "@/components/DialogComponent/MerchantSettledList";
export default {
	name: "SellerCenterManage",
	components: { ChangeMerchantSettled, MerchantSettledList },
	props: {},
	directives: {},
	filters: {},
	extends: {},
	mixins: {},
	data() {
		return {
			hasLineData: false,
			ChangeMerchantDialog: false,
			MerchantSettledListDialog: false,
			ChangeSupplierInfo: {},
			shopId: '',

			dataList: [],
			ecLine1Echarts: null,
			ecFunnel1Echarts: null,
			ecbar1Echarts: null,
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			value2: '',
			suppTYPE: {
				1: '个人',
				2: '企事业单位',
				3: '政府'
			},
			suppStatus: {
				0: '待审核',
				1: '审核通过',
				2: '审核不通过',
				3: '冻结'
			}

		};
	},
	computed: {},
	watch: {},
	created() {
		// 获取查询商家以及店铺统计信息
		this.$http.get(this.$const.SellerCenter.getgeneralInfo).then((res) => {
			console.log(res)
			if (res.code === 200) {
				this.dataList = res.data;
				this.shopId = res.data.shopInfo.id
				this.value2 = getLastWeekData()
				this.confirmDate()
				this.getStoreUserTransactionAnalysisAndStatistics()
			}
		})
	},
	mounted() {
		this.ecLine1Echarts = this.$echarts.init(this.$refs.ecLine1);
		this.ecFunnel1Echarts = this.$echarts.init(this.$refs.ecFunnel1);
		this.ecbar1Echarts = this.$echarts.init(this.$refs.ecbar1);

		this.ecLine1EcFunc()
		this.ecFunnel1EcFunc()
		this.ecbar1EcFunc()
	},
	methods: {
		changeecFunnel1Echarts(userCount) {
			let type = []
			let info = []
			userCount.forEach(item => {
				type.push(item.value)
				info.push({
					value: item.num,
					name: item.value
				})
			})
			this.ecFunnel1Echarts.setOption({
				legend: {
					data: type
				},
				series: [{
					data: info
				},]
			})
		},
		changeecbar1Echarts(userTradingCount) {
			let name = []
			let value = []
			let series = []
			userTradingCount.forEach(item => {
				if (!name.includes(item.name)) {
					name.push(item.name)
				}
				if (!value.includes(item.value)) {
					value.push(item.value)
				}
			})
			value.forEach(item => {
				let arr = []
				userTradingCount.forEach(iitem => {
					if (item === iitem.value) {
						arr.push(iitem.num)
					}
				})
				series.push({
					name: item,
					type: 'bar',
					stack: 'total',
					label: {
						// show: true
					},
					emphasis: {
						focus: 'series'
					},
					data: arr
				})
			})
			this.ecbar1Echarts.setOption({
				yAxis: {
					type: 'category',
					data: name
				},
				series
			})
		},

		async getStoreUserTransactionAnalysisAndStatistics() {
			try {
				let res = await this.$http.get(this.$const.SellerCenter.getStoreUserTransactionAnalysisAndStatistics + this.shopId)
				if (res.code === 200) {
					this.changeecFunnel1Echarts(res.data.userCount)
					this.changeecbar1Echarts(res.data.userTradingCount)
				}
			} catch (e) {
				// console.log(e);
			}
		},

		async confirmDate() {
			let data = {
				"endTime": this.value2[1],
				"shopId": this.shopId,
				"startTime": this.value2[0]
			}
			try {
				let res = await this.$http.post(this.$const.SellerCenter.getStoreTransactionStatistics, data)
				if (res.code === 200) {
					let allOrderTradingCount = res.data.allOrderTradingCount
					let payOrderTradingCount = res.data.payOrderTradingCount
					let date = []
					let allNum = []
					let payNum = []
					allOrderTradingCount.forEach(item => {
						date.push(item.value)
						allNum.push(item.num)
					})
					payOrderTradingCount.forEach(item => {
						payNum.push(item.num)
					})
					if (allOrderTradingCount.length > 0 || payOrderTradingCount.length > 0) {
						this.hasLineData = true
					} else {
						this.hasLineData = false
					}
					this.ecLine1Echarts.setOption({
						graphic: {
							invisible: this.hasLineData, //是否可见，这里的意思是当没有数据时可见
						},
						xAxis: {
							data: date,
						},
						series: [{
							data: allNum
						},
						{
							data: payNum
						}
						]
					})
				}
			} catch (e) {
				// console.log(e);
			}
		},

		ecLine1EcFunc() {
			const option = {
				graphic: {
					type: 'text',
					left: 'center',
					top: 'middle',
					silent: true,
					invisible: this.hasLineData, //是否可见，这里的意思是当没有数据时可见
					style: {
						fill: 'black',
						fontWeight: 'bold',
						text: '暂无数据',
						fontSize: '26px'
					}
				},

				// title: {
				//   text: '订单统计',
				//   left: 'center'
				// },
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b} : {c}'
				},
				legend: {
					left: 'center',
					top: '15px'
				},
				xAxis: {
					type: 'category',
					// name: '月',
					splitLine: { show: false },
					data: [],
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				yAxis: {
					type: 'log',
					// name: '',
					minorSplitLine: {
						show: true
					}
				},
				series: [{
					name: '总订单数',
					type: 'line',
					data: []
				},
				{
					name: '成交订单数',
					type: 'line',
					data: []
				}
				]
			};
			this.ecLine1Echarts.setOption(option)
			//随着屏幕大小调节图表
			window.addEventListener("resize", () => {
				this.ecLine1Echarts.resize();
			});
		},
		ecFunnel1EcFunc() {
			const option = {
				// title: {
				//   text: 'Funnel'
				// },
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b} : {c}%'
				},

				legend: {
					data: []
				},
				series: [{
					name: '',
					type: 'funnel',
					left: '10%',
					width: '80%',
					label: {
						formatter: '{b}: {c}%'
					},
					labelLine: {
						show: false
					},
					itemStyle: {
						opacity: 0.7
					},
					emphasis: {
						label: {
							// position: 'inside',
							formatter: '{b}: {c}%'
						}
					},
					data: []
				},]
			};
			this.ecFunnel1Echarts.setOption(option)
			//随着屏幕大小调节图表
			window.addEventListener("resize", () => {
				this.ecFunnel1Echarts.resize();
			});
		},
		ecbar1EcFunc() {

			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						// Use axis to trigger tooltip
						type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
					}
				},
				legend: {
					bottom: "0",
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'value'
				},
				yAxis: {
					type: 'category',
					data: []
				},
				series: []
			};
			this.ecbar1Echarts.setOption(option)
			//随着屏幕大小调节图表
			window.addEventListener("resize", () => {
				this.ecbar1Echarts.resize();
			});
		},
		//
		ChangeMerchantDialogSuccess() {
			this.ChangeMerchantDialog = false,
				this.MerchantSettledListDialog = false;
		},
		MerchantSettledListDialogSuccess(e) {
			if (e) {
				let jsonP = JSON.parse(e)
				this.ChangeSupplierInfo = jsonP;
			} else {
				var obj={};
				obj=JSON.stringify(this.dataList.supplierInfo);
				this.ChangeSupplierInfo = JSON.parse(obj);
			}
			this.ChangeMerchantDialog = true,
				this.MerchantSettledListDialog = false;
		}
	},
};
</script>

<style lang="scss" scoped>
.sellBody {
	padding: 0 15px;
}

.sellTitle {
	font-weight: 600;
	font-style: normal;
	font-size: 17px;
	color: #333;
	text-align: left;
	line-height: 60px;
}

.sellcont {
	display: flex;
	flex-wrap: wrap;
	font-weight: 400;
	font-style: normal;
	font-size: 16px;
	text-align: left;
	line-height: 30px;
	color: #666;
	padding-bottom: 10px;
}

.sellcontItem {
	width: 23%;
	padding: 10px 2% 10px 0;

	.selltemm {
		font-weight: 700;
	}
}

.sellCard {
	display: flex;
	border: 1px solid #eee;
	padding: 15px 0;
	border-radius: 3px;
	margin-bottom: 20px;

	.sellItem {
		flex: 1;
		border-right: 1px solid #eee;
		padding: 8px 20px;
		padding-left: 60px;
		position: relative;

		.sellItemIcon {
			position: absolute;
			top: 13px;
			left: 25px;
			font-size: 25px;
		}

		.sellItemTitle {
			font-size: 15px;
			line-height: 35px;
			color: #333;
		}

		.sellItemNum {
			font-size: 30px;
			font-weight: 700;
			// color: #555;
			line-height: 40px;
		}

	}

	.sellItem:last-child {
		border-right: 0px;
	}

}

.sellEchartsLine,
.sellEchartsFunnel,
.sellEchartsBar {
	width: 100%;
	height: 40vh;
	background: rgba(252, 251, 251, 0.693);
	border: 1px solid #eee;
}
</style>